import React from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from 'styleguide';

import { setPaletteTab, usePaletteTab } from 'craft/state';

import { tabs, TabMode } from './tabs';

interface Props {
  documentId: number | undefined;
}

export const FullscreenTabs = React.memo(({ documentId }: Props) => {
  const tab = usePaletteTab();
  const dispatch = useDispatch();
  const setTab = (newTab?: string) => dispatch(setPaletteTab(newTab));

  /**
   * This filter is only necessary while we test out the
   * new columns changes.
   */
  const hasFoundTab = tabs.find(
    ({ tabMode, label }) => tabMode === TabMode.FullScreen && label === tab,
  );
  if (!tab || !hasFoundTab) {
    return null;
  }
  const { Component } = hasFoundTab;

  // TODO move Modal to Canoe component
  return (
    <Modal
      isOpen
      toggle={() => setTab()}
      containerStyles={{
        left: '5em',
        right: '1em',
        bottom: '1em',
        top: '40px',
        width: 'auto',
        position: 'absolute',
      }}
    >
      <Modal.Body css={{ padding: '0', maxHeight: '100vh', overflow: 'hidden' }}>
        <Component documentId={documentId} />
      </Modal.Body>
    </Modal>
  );
});
